import React from 'react';
import { isLastElement } from 'globals/utils';
import LeaderSingleRow from './LeaderSingleRow';
import { LeaderSingleRowDataProps } from './LeaderSingleRow/LeaderSingleRow';
import { getAvatarColor } from './LeaderList.utils';
import { WrapperBox } from './LeaderList.style-elements';

interface LeaderListProps {
  leaders: LeaderSingleRowDataProps[];
}

const LeaderList: React.FC<LeaderListProps> = ({ leaders }) => {
  return (
    <WrapperBox>
      {leaders.map(({ id, ...otherProps }, idx) => (
        <LeaderSingleRow
          key={id}
          id={id}
          {...otherProps}
          avatarColor={getAvatarColor(idx % 6)}
          isLast={isLastElement(idx, leaders.length)}
        />
      ))}
    </WrapperBox>
  );
};

export default LeaderList;
